// extracted by mini-css-extract-plugin
export default {"root":"_2G91C","text-block":"_23R18","textBlock":"_23R18","prefix":"k1yn5"};